const getSelectedClass = (classes) => {
  const DEFAULT_CLASS = 'A'
  const urlParams = new URLSearchParams(window.location.search)
  const _paramClass = urlParams.get('class')

  const _selectedClass =
    classes.find(
      (fundClass) => fundClass.className === (_paramClass || DEFAULT_CLASS)
    ) || classes[0]

  return _selectedClass
}

/**
 * Comparator that orders funds by the lower bound of their age-group range.
 *
 * Age groups are strings such as '0-6' or '19+'. The leading number is parsed
 * and compared. Funds missing an ageGroup on either side are treated as equal
 * (returns 0) so the surrounding sort leaves their relative order unchanged.
 *
 * @param {{ageGroup?: string}} a - first fund to compare
 * @param {{ageGroup?: string}} b - second fund to compare
 * @returns {number} -1, 0, or 1 per standard Array.prototype.sort semantics
 */
const sortByAge = (a, b) => {
  if (a.ageGroup && b.ageGroup) {
    let parsedIntA

    if (a.ageGroup.indexOf('-') > 0) {
      parsedIntA = Number(a.ageGroup.split('-')[0])
    } else {
      parsedIntA = Number(a.ageGroup.split('+')[0])
    }

    let parsedIntB

    if (b.ageGroup.indexOf('-') > 0) {
      parsedIntB = Number(b.ageGroup.split('-')[0])
    } else {
      parsedIntB = Number(b.ageGroup.split('+')[0])
    }

    if (parsedIntA > parsedIntB) {
      return 1
    } else if (parsedIntA < parsedIntB) {
      return -1
    } else {
      return 0
    }
  } else {
    return 0
  }
}

/**
 * Filters the target-allocation single-fund portfolio list, excluding the
 * "Columbia 529" entries that should not appear in that view.
 *
 * @param {Array<{name: string}>} funds - source fund list
 * @returns {Array<{name: string}>} funds whose name does not contain 'Columbia 529'
 */
const parseDataTarget = (funds) => {
  return funds.filter((f) => f.name.indexOf('Columbia 529') < 0)
}

/**
 * Expands age-based portfolio funds into one entry per glide-path value and
 * groups them in fixed order: AGGRESSIVE, then MODERATE, then CONSERVATIVE.
 *
 * Each source fund carries a 'glidePath' filter whose filterValue is a list of
 * glide-path options. For every option a shallow fund copy is produced with its
 * glidePath (code) and ageGroup (desc) set. Options with a code outside the
 * three known buckets are dropped.
 *
 * @param {Array<{filters: Array<{filter: string, filterValue?: Array<{code: string, desc: string}>}>}>} funds
 * @returns {Array<object>} flattened, grouped fund copies
 */
const parseDataAge = (funds) => {
  const aggressiveData = []
  const moderateData = []
  const conservativeData = []

  funds.forEach((fund) => {
    const glidePathFilter = fund.filters.filter((index) => {
      return index.filter == 'glidePath'
    })[0]

    if (glidePathFilter && glidePathFilter.filterValue) {
      glidePathFilter.filterValue.forEach((index) => {
        const fundCopy = { ...fund }

        fundCopy.glidePath = index.code
        fundCopy.ageGroup = index.desc

        if (index.code == 'AGGRESSIVE') {
          aggressiveData.push(fundCopy)
        } else if (index.code == 'MODERATE') {
          moderateData.push(fundCopy)
        } else if (index.code == 'CONSERVATIVE') {
          conservativeData.push(fundCopy)
        }
      })
    }
  })

  return [].concat(aggressiveData, moderateData, conservativeData)
}

export { getSelectedClass, sortByAge, parseDataTarget, parseDataAge }
